"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const _ = __importStar(require("lodash"));
const moment_1 = __importDefault(require("moment"));
require("./singleChat.scss");
const chatSlice_1 = require("../../../../redux/slices/chatSlice");
const slider_1 = __importDefault(require("../slider/slider"));
const svgIcons_1 = require("../../../../svgIcons");
const avatar_1 = __importDefault(require("../avatar/avatar"));
const core_1 = require("@material-ui/core");
const common_1 = require("../../../../utils/common");
const common_2 = require("../../../../utils/common");
const helper_1 = __importDefault(require("./helper"));
const components_1 = require("./components");
class SingleChat extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            messageObj: null,
            modalOpen: false,
            triggered: false,
            sliderActive: false,
            initialSlide: null,
        };
        this.chatListRef = react_1.createRef();
        // trigger slider
        this.initSlider = (i) => {
            this.setState({ sliderActive: true, initialSlide: i });
            this.helper.triggerBodyFix(true);
            // @ts-ignore
            document.querySelector('.content-container').style.paddingBottom = 0;
            this.helper.triggerChatContainerScroll(true);
        };
        this.inputFocus = (evnt) => this.helper.inputFocus(evnt);
        this.inputBlur = (e) => this.helper.inputBlur(e);
        // dismiss slider
        this.closeSlider = () => {
            this.setState({ sliderActive: false });
            //this.helper.triggerBodyFix(false);
            // @ts-ignore
            document.querySelector('.content-container').style.paddingBottom = 0;
            this.helper.triggerChatContainerScroll(false);
        };
        this.onKeyPress = (e) => {
            if (!common_2.isMobileBrowser().check) {
                this.helper.calculateParentWrapperHeight();
            }
            if (!common_2.ifMobile() && !common_2.isMobileBrowser().check) {
                this.sendMessage(e);
            }
        };
        this.onKeyUp = (e) => {
            if (!common_2.isMobileBrowser().check) {
                this.helper.calculateParentWrapperHeight();
            }
        };
    }
    componentDidMount() {
        const { case_id, fatt_id, cr_id, tr_id, rc_id } = this.props.case;
        this.props.getMessageList(case_id || fatt_id || cr_id || tr_id || rc_id);
        this.initHelper();
        setTimeout(() => {
            this.helper.triggerBodyFix(true);
        }, 500);
        setTimeout(() => this.helper.calculateParentWrapperHeight(), 500);
        if (!common_2.ifMobile() && !common_2.isMobileBrowser().check) {
            //window.addEventListener('resize', this.helper.calculateParentWrapperHeight);
        }
        window.addEventListener('resize', this.helper.calculateParentWrapperHeight);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.helper.scrollToBottom();
    }
    initHelper() {
        if (!this.helper && (this.chatListRef && this.chatListRef.current)) {
            this.helper = new helper_1.default(this.chatListRef);
            setTimeout(() => this.helper.scrollToBottom(), 600);
            this.helper.prepareContent();
        }
    }
    async componentWillUnmount() {
        const { case_id, fatt_id, cr_id, tr_id, rc_id } = this.props.case;
        await this.props.resetChat(case_id || fatt_id || cr_id || tr_id || rc_id);
        this.helper.deregister();
        this.helper.triggerBodyFix(false);
        // @ts-ignore
        const contentContainer = document.querySelector('.content-container');
        window.innerWidth >= 767 ? contentContainer.style.paddingBottom = '60px' : contentContainer.style.paddingBottom = '125px';
        const pageWrapper = document.querySelector('#page_wrapper');
        pageWrapper.style.height = '';
        document.body.classList.remove('overflow-y-hidden');
        if (common_2.ifMobile() && (this.chatListRef && this.chatListRef.current)) {
            this.chatListRef.current.style.height = '';
        }
        else {
            window.removeEventListener('resize', this.helper.calculateParentWrapperHeight);
        }
    }
    // send new message
    sendMessage(e) {
        const textarea = document.getElementById('message-text-input');
        const txt = textarea.value;
        if (((e.key === 'Enter' && !e.shiftKey) || (e.type === 'click' || e.type === 'touchend')) && /\S/.test(txt)) {
            e.preventDefault();
            e.stopPropagation();
            const { case_id, fatt_id, cr_id, tr_id, rc_id } = this.props.case;
            this.props.sendMessage({
                message: txt.replace(/^\s+|\s+$/g, ''),
                case: case_id,
                fatt_id,
                cr_id,
                tr_id,
                rc_id
            });
            textarea.value = '';
            this.helper.scrollToBottom();
            if (!common_2.isMobileBrowser().check) {
                setTimeout(() => {
                    this.helper.calculateParentWrapperHeight();
                }, 100);
            }
        }
    }
    onAttachment(e) {
        const file = e.target.files[0];
        const regExp = /([a-zA-Z0-9\s_\\/\.\-\(\):])+(doc|docx|pdf|jpg|jpeg|png|text|gif|vnd.openxmlformats-officedocument.wordprocessingml.document)$/i;
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = ev => {
            const { case_id, fatt_id, cr_id, tr_id, rc_id } = this.props.case;
            const { chat } = this.props;
            const data = new FormData();
            if (case_id) {
                data.append('case', case_id.toString());
            }
            if (fatt_id) {
                data.append('fatt_id', fatt_id.toString());
            }
            if (cr_id) {
                data.append('cr_id', cr_id === null || cr_id === void 0 ? void 0 : cr_id.toString());
            }
            if (tr_id) {
                data.append('tr_id', tr_id === null || tr_id === void 0 ? void 0 : tr_id.toString());
            }
            if (rc_id) {
                data.append('rc_id', rc_id === null || rc_id === void 0 ? void 0 : rc_id.toString());
            }
            data.append('file', file);
            return this.props.attachFile(data, {
                preview: reader.result,
                type: file.type,
                name: file.name,
                user: this.props.user,
                isValid: regExp.test(file.type) || regExp.test(file.name),
                index: (chat.messages.length + 1)
            });
        };
    }
    // check if message sender is current user
    isChatUser(chatUserId) {
        return this.props.user.id === chatUserId;
    }
    // delete message
    deleteMessage(message) {
        this.props.deleteMessage(message);
        this.closeModal();
    }
    // open message delete modal
    openModal(message) {
        this.setState({
            modalOpen: true,
            messageObj: message
        });
    }
    // close message delete modal
    closeModal() {
        this.setState({
            modalOpen: false,
            messageObj: null
        });
    }
    // init slider from message list, by clicked img
    getMediaIndex(img) {
        const index = this.props.chat.media.findIndex(el => el.name === img.name);
        this.initSlider(index);
    }
    // show or hide case details on mobile view
    async triggerCaseInfo() {
        await this.setState({ triggered: !this.state.triggered });
        const { triggered } = this.state;
        if (triggered) {
            this.helper.triggerBodyFix(false);
            this.helper.deregister(true);
            this.helper.updateCaseInfoHeightOnMobile(true);
        }
        else {
            this.helper.triggerBodyFix(true);
            this.helper.prepareContent();
            this.helper.updateCaseInfoHeightOnMobile(false);
        }
    }
    render() {
        const { chat } = this.props;
        const { messages, media, files, activeChat } = chat;
        const caseData = activeChat.case;
        const grouped = _.groupBy(messages, 'created');
        const list = [];
        const acceptableFiles = common_2.ifMobile() ? '*' : 'image/jpeg, image/jpg, image/png, application/pdf, .doc, .pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain';
        let caseStatus;
        if (activeChat.fatt_id) {
            caseStatus = common_1.CASE_STATUSES['fatt'][caseData.status];
        }
        else if (activeChat.tr_id) {
            caseStatus = common_1.CASE_STATUSES['tr'][caseData.status];
        }
        else if (activeChat.cr_id) {
            caseStatus = common_1.CASE_STATUSES['cr'][caseData.status];
        }
        else {
            caseStatus = common_1.getCaseStatus(caseData.status);
        }
        let userLink;
        if (activeChat.tr_id) {
            userLink = `tr-profile?id=${activeChat.sender.id}`;
        }
        else if (activeChat.cr_id) {
            userLink = `profile?id=${activeChat.sender.id}`;
        }
        else {
            userLink = `profile-guest?id=${activeChat.sender.id}`;
        }
        for (const [index, key] of Object.keys(grouped).entries()) {
            list.push(react_1.default.createElement("h5", { className: "main-date", key: index }, key));
            list.push(...grouped[key]);
        }
        if (!this.helper) {
            this.initHelper();
        }
        const renderedList = list.map((el, i) => {
            if (el.body) {
                const elOrigin = el;
                el = (el.body.message || el.body.attachments) && (react_1.default.createElement(core_1.Box, { key: el.id, display: 'flex', style: (i === (list.length - 1) && (common_2.ifMobile() || (common_2.isMobileBrowser().check))) ? { 'marginBottom': '20px' } : {}, flexDirection: this.isChatUser(el.from.id) ? 'row-reverse' : 'row' },
                    react_1.default.createElement(core_1.Box, { className: 'chat-message-box', alignSelf: this.isChatUser(el.from.id) ? 'flex-end' : '' },
                        react_1.default.createElement(core_1.Box, { display: 'flex', flexDirection: 'column' },
                            react_1.default.createElement(core_1.Box, { display: 'flex', justifyContent: this.isChatUser(el.from.id) ? 'flex-end' : 'flex-start' },
                                react_1.default.createElement(core_1.Box, { alignSelf: !this.isChatUser(el.from.id) ? 'flex-end' : 'center' },
                                    !this.isChatUser(el.from.id) &&
                                        react_1.default.createElement(avatar_1.default, { imageUrl: activeChat.sender.imageUrl }),
                                    (this.isChatUser(el.from.id) && !elOrigin.previewIndex) &&
                                        react_1.default.createElement(svgIcons_1.DeleteMessageIcon, { onClick: () => this.openModal(elOrigin), className: 'v2-delete-icon' })),
                                el.body.message && !el.body.attachements &&
                                    react_1.default.createElement("p", { className: `text ${this.isChatUser(el.from.id) ? 'chat-user' : ''}`, dangerouslySetInnerHTML: { __html: el.body.message.replace(/\n/g, "<br />") } }),
                                el.body.attachments && !el.body.message &&
                                    react_1.default.createElement("p", { className: `attachment
                                    ${el.isInvalid ? 'disabled-opacity' : null}
                                    ${common_1.isImage(el.body.attachments[0].type) ? 'image' : 'file'}
                                    ${this.isChatUser(el.from.id) ? 'right' : 'left'}` }, common_1.isImage(el.body.attachments[0].type) ?
                                        react_1.default.createElement("img", { onClick: (e) => this.getMediaIndex(elOrigin.body.attachments[0]), src: this.helper.generatePreviewUrl(el.body.attachments[0]) }) :
                                        react_1.default.createElement("a", { className: 'attachment-link', onClick: (e) => {
                                                this.helper.downloadFile(elOrigin.body.attachments[0]);
                                            } }, el.body.attachments[0].name))),
                            el.isInvalid ?
                                react_1.default.createElement(core_1.Box, { alignSelf: 'flex-end', className: 'error-msg' }, "File type must be pdf, jpg, jpeg, png, doc, docx or text.") :
                                react_1.default.createElement(core_1.Box, { alignSelf: this.isChatUser(el.from.id) ? 'flex-end' : '', className: `date ${!this.isChatUser(el.from.id) ? "sender-date" : ''}` }, el.previewIndex ? 'Uploading...' : moment_1.default(el.createdAt).format('h:mm A'))))));
            }
            return el;
        });
        return (react_1.default.createElement("section", { id: 'single-chat-container' },
            this.state.sliderActive &&
                react_1.default.createElement(slider_1.default, { closeSlider: this.closeSlider, initialSlide: this.state.initialSlide }),
            react_1.default.createElement("header", { className: 'single-chat-header' },
                react_1.default.createElement("a", { target: '_blank', className: 'text', href: `#/${userLink}` },
                    react_1.default.createElement("h4", null, activeChat.sender.name)),
                react_1.default.createElement(core_1.Hidden, { mdUp: true },
                    react_1.default.createElement("div", { className: "mobile-switch", onClick: () => this.triggerCaseInfo() }, this.state.triggered ? react_1.default.createElement("div", { className: "v2-close" }) : react_1.default.createElement("div", { className: "arrow" })))),
            react_1.default.createElement("section", { className: `case-details-container ${this.state.triggered ? 'visible' : ''}` },
                react_1.default.createElement(components_1.CaseStatus, { caseStatus: caseStatus, caseData: caseData }),
                react_1.default.createElement(components_1.CaseInfo, { caseData: caseData, activeChat: activeChat }),
                react_1.default.createElement(components_1.Media, { helper: this.helper, files: files, media: media, triggerSlider: this.initSlider })),
            react_1.default.createElement("section", { className: `chat ${!this.state.triggered ? '' : 'hidden'}` },
                react_1.default.createElement("div", { className: 'message-parent', ref: this.chatListRef },
                    react_1.default.createElement("div", { className: 'messages-wrapper' },
                        react_1.default.createElement("div", { className: "message-list", id: "apc-messages-list" }, renderedList))),
                react_1.default.createElement(core_1.Box, { className: 'message-field-wrapper' },
                    react_1.default.createElement(core_1.TextField, { className: 'message-field', size: 'medium', id: 'message-text-input', multiline: true, rows: 1, rowsMax: 3, onFocus: (e) => this.inputFocus(e), onBlur: (e) => this.inputBlur(e), onKeyPress: (e) => this.onKeyPress(e), onKeyUp: (e) => this.onKeyUp(e), placeholder: 'Type your message here', variant: "outlined", InputProps: {
                            endAdornment: react_1.default.createElement(core_1.Box, { className: 'icons-wrapper' },
                                react_1.default.createElement("label", { htmlFor: 'attach-file-input', className: "clip-icon" },
                                    react_1.default.createElement(svgIcons_1.ClipIcon, { style: {
                                            fontSize: '16px',
                                        } })),
                                react_1.default.createElement("div", { className: "send-message-icon", onClick: (e) => this.sendMessage(e), onTouchEnd: (e) => this.sendMessage(e) },
                                    react_1.default.createElement(svgIcons_1.SendMessageIcon, { style: {
                                            fontSize: '13px',
                                            fill: '#AFAFB8'
                                        } })))
                        } }),
                    react_1.default.createElement("input", { type: "file", className: 'hidden', id: 'attach-file-input', name: "file", accept: acceptableFiles, onChange: (e) => this.onAttachment(e) }))),
            react_1.default.createElement(core_1.Dialog, { open: this.state.modalOpen, onClose: () => this.closeModal(), fullWidth: true, maxWidth: 'sm', className: 'v2-modal-container' },
                react_1.default.createElement("p", { className: "text" }, "Are you sure you want to delete this message?"),
                react_1.default.createElement(core_1.Box, { display: 'flex', justifyContent: 'flex-end', className: 'btns-wrapper' },
                    react_1.default.createElement(core_1.Button, { className: 'v2-btn v2-btn-danger', onClick: () => this.deleteMessage(this.state.messageObj) }, "Delete"),
                    react_1.default.createElement(core_1.Button, { className: 'v2-btn v2-btn-tertiary', onClick: () => this.closeModal() }, "Never Mind")))));
    }
}
const mapStateToProps = (state) => {
    const { chat, user } = state;
    return {
        chat,
        user
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getMessageList: (id) => dispatch(chatSlice_1.getChatMessages(id)),
        sendMessage: (msg) => dispatch(chatSlice_1.sendMessage(msg)),
        attachFile: (msg, preview) => dispatch(chatSlice_1.attachFile(msg, preview)),
        deleteMessage: (msg) => dispatch(chatSlice_1.deleteMessage(msg)),
        resetChat: (id) => dispatch(chatSlice_1.reset(id))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SingleChat);
